import { Input, type InputProps } from '@chakra-ui/react'
import { forwardRef, useState } from 'react'

const formatCpf = (digits: string) =>
  digits
    .slice(0, 11)
    .replace(/(\d{3})(\d)/, '$1.$2')
    .replace(/(\d{3})(\d)/, '$1.$2')
    .replace(/(\d{3})(\d{1,2})$/, '$1-$2')

const formatCnpj = (digits: string) =>
  digits
    .slice(0, 14)
    .replace(/(\d{2})(\d)/, '$1.$2')
    .replace(/(\d{3})(\d)/, '$1.$2')
    .replace(/(\d{3})(\d)/, '$1/$2')
    .replace(/(\d{4})(\d{1,2})$/, '$1-$2')

const CpfCnpjInput = forwardRef<HTMLInputElement, InputProps>(({ onChange, ...props }, ref) => {
  const [value, setValue] = useState('')

  const isCnpj = value.replace(/\D/g, '').length > 11

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const digits = e.target.value.replace(/\D/g, '').slice(0, 14)
    const formatted = digits.length > 11 ? formatCnpj(digits) : formatCpf(digits)
    setValue(formatted)
    const syntheticEvent = { ...e, target: { ...e.target, value: formatted } }
    onChange?.(syntheticEvent as React.ChangeEvent<HTMLInputElement>)
  }

  return (
    <Input
      {...props}
      ref={ref}
      type="text"
      inputMode="numeric"
      value={value}
      onChange={handleChange}
      placeholder={isCnpj ? '00.000.000/0000-00' : '000.000.000-00'}
    />
  )
})

export default CpfCnpjInput
